module.exports = __webpack_public_path__ + "img/yjd_2.4650a5a4.png";